import { companiesConstants } from '../constants'

const initialState = {
  list: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null
}

export default function companies(state = initialState, action) {
  switch (action.type) {
    case companiesConstants.LOADING_COMPANIES:
      return { ...state, loading: true, error: null }
    case companiesConstants.LOADING_COMPANIES_ERROR:
      return { ...state, loading: false, error: action.payload }
    case companiesConstants.UPDATE_COMPANY:
      return {
        ...state,
        list:
          state.list === null
            ? [action.payload]
            : state.list.findIndex((x) => x.id === action.payload.id) === -1
            ? state.list.concat(action.payload)
            : state.list.map((item) => {
                return item.id === action.payload.id ? action.payload : item
              })
      }
    case companiesConstants.REMOVE_COMPANY:
      return {
        ...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload.id
        }),
        loading: false
      }
    case companiesConstants.COMPANY_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case companiesConstants.COMPANY_AJAX_SUCCESS:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    case companiesConstants.COMPANY_AJAX_FAILURE:
      return { ...state, ajaxSpinner: false, ajaxStatus: action.payload }
    default:
      return state
  }
}
